import { clickOutside } from "./v-click-outside";

export const directives = [
  clickOutside,
]